<div class="footer-note-container">
  @if (isMortgageSimulator) {
    <div class="footer-note">
      <p class="note-title">Esta simulación es de carácter informativo<p>
      <p class="note-text">Esta simulación no es una oferta vinculante. Esta simulación es únicamente de carácter informativo y para fines ilustrativos por lo que no implica asunción de obligación ni compromiso por parte de Banco Santander México S.A., ni de Entidad alguna referida en el presente documento, integrante o no del Grupo Financiero Santander México. Las condiciones del producto, criterios de elegibilidad, planes, importes de beneficios y políticas de crédito que se refieren en el simulador están sujetas a cambio sin previo aviso. La autorización del crédito es una facultad discrecional de Banco Santander México S.A por lo que se reserva el derecho de otorgarla o negarla. Banco Santander México S.A. se reserva el derecho de solicitar información adicional y/o restringir parámetros de enganche, monto, plazo o tasa en función de las características específicas del solicitante y del inmueble. Los productos hipotecarios son emitidos por Banco Santander México, S.A., Institución de Banca Múltiple, Grupo Financiero Santander México. Para conocer las características, términos, comisiones, requisitos de contratación, tasa de Interés aplicable, vigencia, restricciones y beneficios del producto, consulta www.santander.com.mx. Disponible en toda la República Mexicana. El cálculo en el seguro de referencia es única y exclusivamente con fines informativos e ilustrativos. La calidad en la prestación de los servicios y responsabilidad en el otorgamiento de los mismos es responsabilidad directa de Zúrich Santander Seguros México S.A. y/o de la aseguradora con la que contrate estos seguros.</p>
    </div>
  } @else {
    <div class="footer-note">
      <p class="note-title">Servicios entregados por HomeIn y proveedores asociados.<p>
      <p class="note-text">HomeIn SPA, será el responsable exclusivo de la operación y funcionamiento del presente sitio, por tanto, Banco Santander México, S.A. Institución de Banca Múltiple, Grupo Financiero Santander México, se libera de cualquier responsabilidad relacionada con el presente sitio y no es responsable por la calidad de dichos productos y servicios.</p>
    </div>
  }
</div>
<footer class="footer">
  <div class="footer-container">
    <div class="logo"></div>
    <div class="content-container">
      <div class="section">
        <div class="title">¿Qué deseas hacer?</div>
        <ul>
          <li><a routerLink="/moving" id="btn-link-NaPXDUNr">Mudarme de hogar</a></li>
          <li><a routerLink="/remodeling" id="btn-link-2dJOM8Xe">Remodelar mi hogar</a></li>
          <li><a routerLink="/ecommerce" id="btn-link-pWY0xIMk">Compras para el hogar</a></li>
          <li><a routerLink="/home-assistance" id="btn-link-BT13gAOi">Planes de asistencia</a></li>
          <li><a routerLink="/warehouse" id="btn-link-W7knyd2-">Rentar bodega</a></li>
          <li><a routerLink="/desarrolladores" id="btn-link-ZVbRxNwk">Encontrar inmueble</a></li>
        </ul>
      </div>
      <div class="section">
        <h2 class="title">¿Eres nuevo?</h2>
        <ul>
          <li><a routerLink="/what-is-mundo-hogar" id="btn-link-uQwnjoBa">¿Qué es Mundo Hogar?</a></li>
          <li><a routerLink="/enrollment/sign-up" id="btn-link-AMe9UHZ1">Crea cuenta Mundo Hogar</a></li>
        </ul>
      </div>
      <div class="section">
        <h2 class="title">Ayuda</h2>
        <ul>
          <li><a href="https://ayuda.mundohogar.com.mx/" target="_blank" id="btn-link-dFZ7WA6_">Ir al centro de ayuda</a></li>
          <li><a href="https://ayuda.mundohogar.com.mx/preguntas-frecuentes" target="_blank" id="btn-link-rsrrnpA4">Preguntas frecuentes</a></li>
          <li><a href="https://ayuda.mundohogar.com.mx/aviso-de-privacidad" target="_blank" id="btn-link-6SlfJF4M">Aviso de privacidad</a></li>
          <li><a href="https://ayuda.mundohogar.com.mx/terminos-y-condiciones" target="_blank" id="btn-link-W6S-_PC8">Términos y condiciones</a></li>
          <li><a routerLink="/complaints-and-returns" id="btn-link-VpFcM2w9">Reclamos y devoluciones</a></li>
          <li><a routerLink="/contact" id="btn-link-iUw-BwBq">Contacto</a></li>
        </ul>
      </div>
      <div class="section">
        <div class="title">Banco Santander</div>
        <ul>
          <li><a routerLink="/credit-card" id="btn-link-CrtSe0fD">Tarjeta de crédito</a></li>
          <li><a routerLink="/mortgage-simulator" id="btn-link-v663lQDt">Crédito hipotecario</a></li>
          <li><a routerLink="/benefits" id="btn-link-hW7hThNK">Crédito personal</a></li>
          <li><a href="https://onboarding.santander.com.mx/cuenta-digital-lite/product-page?utm_source=Mundo_Hogar&utm_medium=Boton_N2&utm_campaign=AperturaCuentaDigitalN2" target="_blank" rel="noopener" id="btn-link-KLyazEw1">Hazte cliente</a></li>
        </ul>
      </div>
      <!-- TODO: enable this later on -->
      <!--<div class="section">
        <div class="title">Síguenos en redes sociales</div>
        <div class="social">
          <a href="https://www.facebook.com/" target="_blank" rel="noopener" id="btn-link-KZlCqcZ-"><i class="icon-facebook"></i></a>
          <a href="https://www.instagram.com/" target="_blank" rel="noopener" id="btn-link-Gl6rpAQM"><i class="icon-instagram"></i></a>
        </div>
      </div>-->
    </div>
  </div>
  <div class="version">MHv{{ appVersionCode }}</div>
</footer>
